export default "__VITE_ASSET__CB3UvdMl__"